module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-7.png?02df9a4c";